const USER_TYPE = window.AppConfig.USER_TYPES;

const VERIFY_AUTHORIZATION = current_user_info => {
	
	return {
		isSUPER_ADMIN:
			current_user_info !== null && current_user_info?.attributes['custom:user_type'] === USER_TYPE.SUPER_ADMIN,
		isCUSTOMER_SERVICE:
			current_user_info !== null &&
			current_user_info?.attributes['custom:user_type'] === USER_TYPE.CUSTOMER_SERVICE,
		isCOMMERCIAL:
			current_user_info !== null && current_user_info?.attributes['custom:user_type'] === USER_TYPE.COMMERCIAL,
		isACCOUNTING:
			current_user_info !== null && current_user_info?.attributes['custom:user_type'] === USER_TYPE.ACCOUNTING,
		isADMIN: current_user_info !== null && current_user_info?.attributes['custom:user_type'] === USER_TYPE.ADMIN
	};
};

module.exports = {
	VERIFY_AUTHORIZATION
};
